module.exports = __webpack_public_path__ + "static/media/r26.451cea2a.webp";